import _ from 'lodash/fp';
import { createReducer } from 'reduxsauce';
import { STUDENT, USER_ID } from 'actions/Base';

export const INITIAL_STATE = {
  isLoading: false,
};

export const onGetStudentRequest = (state) => ({ ...state, isLoading: true });
export const onGetStudentFailure = (state) => ({ ...state, isLoading: false });
export const onGetStudentSuccess = (state, { payload }) => {
  // const current = _.cloneDeep(_.get(USER_ID(payload))(state) || {});
  // const content = Object.values([current, payload], {}).reduce((unique, o) => {
  //         if(!unique.some(obj => obj.id === o.id)) {
  //           unique.push(o);
  //         }
  //         return unique;
  //     },[]);
  state.isLoading = false
  return _.set(USER_ID(payload), payload)(state);
};

export const ACTION_HANDLERS = {
  [STUDENT.GET_REQUEST]: onGetStudentRequest,
  [STUDENT.GET_FAILURE]: onGetStudentFailure,
  [STUDENT.GET_SUCCESS]: onGetStudentSuccess
};

export default createReducer(INITIAL_STATE, ACTION_HANDLERS);
